import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=025e640e&scoped=true&"
import script from "./forgot-password.vue?vue&type=script&lang=ts&"
export * from "./forgot-password.vue?vue&type=script&lang=ts&"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=025e640e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e640e",
  null
  
)

export default component.exports